import { FontFamily, FontWeight } from "../brand-kit";

export enum FaqForgeElementType {
  RICH_TEXT = "rich-text",
  IMAGE = "image",
}

type BaseElement<T extends FaqForgeElementType> = {
  type: T;
};

export interface FaqRichTextElement
  extends BaseElement<FaqForgeElementType.RICH_TEXT> {
  id: number;
  html: string;
  fontFamily: FontFamily;
  fontWeight: FontWeight;
  fontSizePx: number;
  textColor: string;
  linkColor: string;
}

export interface FaqImageElement
  extends BaseElement<FaqForgeElementType.IMAGE> {
  url: string;
}

export type FaqForgeElement = FaqRichTextElement | FaqImageElement;
